import React from 'react';
import { Calendar, Tag } from 'lucide-react';
import type { BlogPost } from '../../types/blog';
import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface BlogCardProps {
  post: BlogPost;
  featured?: boolean;
}

export const BlogCard: React.FC<BlogCardProps> = ({ post, featured }) => {
  // Safely format the date
  const formatPublishDate = (dateString: string | null) => {
    try {
      if (!dateString) return '';
      return format(parseISO(dateString), 'PP', { locale: ptBR });
    } catch (error) {
      console.error('Error formatting date:', error);
      return '';
    }
  };

  return (
    <article
      className={`bg-white/10 backdrop-blur-lg rounded-lg overflow-hidden transition-all duration-300 hover:transform hover:scale-[1.02] ${
        featured ? 'md:col-span-2' : ''
      }`}
    >
      <div className="relative">
        <img
          src={post.imageUrl}
          alt={post.title}
          className="w-full h-48 object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-indigo-950/80 to-transparent" />
      </div>

      <div className="p-6">
        <div className="flex items-center space-x-4 mb-4">
          <span className="text-sm text-purple-200/70 flex items-center">
            <Calendar className="w-4 h-4 mr-1" />
            {formatPublishDate(post.createdAt)}
          </span>
        </div>

        <h3 className="text-xl font-bold text-purple-200 mb-2">
          {post.title}
        </h3>

        <p className="text-purple-200/70 mb-4 line-clamp-2">
          {post.excerpt}
        </p>

        <div className="flex items-center justify-between">
          <span className="text-sm text-purple-300 flex items-center">
            <Tag className="w-4 h-4 mr-1" />
            {post.categoryName}
          </span>
          <button className="text-purple-300 hover:text-purple-200 transition-colors">
            Ler mais →
          </button>
        </div>
      </div>
    </article>
  );
};